export const environment = {
  production: true,
  url: 'https://apirhnetws.tjba.jus.br/',
  packageFile: './../../../../package.json',
  VERSION: require('../../package.json').version
};